import React, { useEffect, useState } from "react";

import {
  TableCell,
  TableText,
  TableRow,
} from "../../../../../../../Components/FinalTable";


import TableAction from "./TAction";

import { toTZS } from "../../../../../../../Util/Currency";

const TRow = ({ doc }) => {
  
  return (
    <>
      <TableRow key={doc.id}>
        <TableCell w={90 / 5}>
          <TableText label={doc.fixed_assets.name} />
        </TableCell>
        <TableCell w={90 / 5}>
          <TableText label={doc.fixed_assets.fixed_assets_categories.name} />
        </TableCell>
        <TableCell w={90 / 5}>
          <TableText label={toTZS(doc.fixed_assets.unit_cost)} />
        </TableCell>
        <TableCell w={90 / 5}>
          <TableText label={doc.fixed_assets.store_qty} />
        </TableCell>
        <TableCell w={90 / 5}>
          <TableText label={`${doc.qty}`} />
        </TableCell>
        <TableCell>
          <TableAction doc={doc} />
        </TableCell>
      </TableRow>
    </>
  );
};

export default TRow;
